(function () {
    'use strict';

    angular.module("imApp").factory("p2DataTaskLogService", ['$ihttp', function ($ihttp) {
        let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 354,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
